import { APIResponse } from "@copetence/shared";
import i18n from "i18n";
import { env } from "../constants/envConfig";

class REST {
    request = async <D>(url: string, method: "GET" | "POST" | "DELETE", options: {
        body?: any
        headers?: any
        responseType?: XMLHttpRequestResponseType;
    }): Promise<APIResponse<D>> => {
        const headers = {
            'accept': 'application/json',
            ...options.headers
        };

        headers['Accept-Language'] = i18n.language.slice(0,2);

        const ops: RequestInit = {
            method: method,
            redirect: "follow" as RequestRedirect,
            headers: headers,
            // mode: "no-cors"
        };

        if (options.body) {
            if (options.body instanceof FormData) {
                ops.body = options.body;
            } else {
                headers['Content-Type'] = 'application/json';
                ops.body = JSON.stringify(options.body);
            }
        }

        // Add * to the start of the url to fetch outside of base API
        const requestURL = env.REACT_APP_API_URL + url;

        return new Promise(async (resolve, reject) => {
            fetch(requestURL, ops)
                .then(async (response) => {
                    const contentType = response.headers.get('Content-Type');
                    let data;
                    if (options.responseType === 'blob' || (contentType && contentType.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document'))) {
                        data = await response.blob();
                    } else if (contentType && contentType.includes('application/json')) {
                        data = await response.json();
                    } else {
                        data = await response.text();
                    }
                    return data
                })
                .then(async (response) => {
                    console.log(response)
                    if (response.error) {
                        // window.alert(response.error.displayMessage);
                    }

                    const apiResponse: APIResponse<D> = response as APIResponse<D>;
                    return resolve(apiResponse);
                })
                .catch(async (error) => {
                    reject(error);
                });
        });
    }

    get = async <D>(url: string, options?: {
        headers?: any
        responseType?: XMLHttpRequestResponseType;
    }): Promise<APIResponse<D>> => {
        return new Promise<APIResponse<D>>(async (resolve, reject) => {
            this.request<D>(url, "GET", {
                headers: options?.headers,
            }).then(async (response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    post = async <D>(url: string, options?: {
        body: any
        headers?: any
    }): Promise<APIResponse<D>> => {
        return new Promise<APIResponse<D>>(async (resolve, reject) => {
            this.request<D>(url, "POST", {
                body: options?.body,
                headers: options?.headers,
            }).then(async (response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    delete = async <D>(url: string, options?: {
        headers?: any
    }): Promise<APIResponse<D>> => {
        try {
            const response = await this.request<D>(url, "DELETE", {
                headers: options?.headers
            });
            return response;
        } catch (error) {
            console.error("Error during DELETE request:", error);
            throw error;
        }
    }
}

export const API = new REST();